import { FC } from 'react'

import { EDocumentType } from '../../../models'
import { FormFieldLoading, FormLabel, FormTitle, Input, Radio } from '../../UI'
import { useUserDocumentsTypes } from '../../../hooks'

type ContactPatientFormProps = {
  className?: string,
  patient: any,
  documentTypeName?: string
}

const ContactPatientForm:FC<ContactPatientFormProps> = ({ className = '', patient, documentTypeName = 'documentTypeId' }) => {

  const documentsTypes = useUserDocumentsTypes()

  const getDocumentTypeName = () => {
    if(patient?.document_type_id === EDocumentType.rut) return 'run'
    else if(patient?.document_type_id === EDocumentType.passport) return 'pasaporte'
    else return 'run o pasaporte'
  }

  return (
    <div className={className}>
      <FormTitle size="14">Identificación del paciente </FormTitle>

      <fieldset className="mt-20">
        <FormLabel htmlFor="firstName">Nombre</FormLabel>
        <Input
          id="firstName"
          name="firstName"
          value={patient?.first_name?.toUpperCase()}
          placeholder="Nombre"
          fullWidth
          disabled
          className="mt-10"
        />
      </fieldset>

      <fieldset className="mt-30">
        <FormLabel htmlFor="lastName">Primer apellido</FormLabel>
        <Input
          id="lastName"
          name="lastName"
          value={patient?.last_name?.toUpperCase()}
          placeholder="Apellido"
          fullWidth
          disabled
          className="mt-10"
        />
      </fieldset>

      <fieldset className="mt-30">
        <FormLabel htmlFor="secondName">Segundo apellido</FormLabel>
        <Input
          id="secondName"
          name="secondName"
          value={patient?.second_name?.toUpperCase()}
          placeholder="Apellido"
          fullWidth
          disabled={true}
          className="mt-10"
        />
      </fieldset>

      <fieldset className="mt-30">
        <FormLabel>Tipo de documento</FormLabel>
        <div className="position-relative mt-10">
          {documentsTypes.data ?
              documentsTypes.data.map((it: any, i: number) => {
                const fieldId: string = `${documentTypeName}${i}`
                return (
                  <div key={i} className={`d-inline-block ${i > 0 ? 'ml-30' : ''}`}>
                    <Radio
                      id={fieldId}
                      name={documentTypeName}
                      value={EDocumentType.rut}
                      checked={patient?.document_type_id === it.id}
                      disabled
                    />
                    <FormLabel htmlFor={fieldId} className="d-flex">{it.name}</FormLabel>
                  </div>
                )
              })
            :
              <FormFieldLoading overlay />
          }
        </div>
      </fieldset>

      <fieldset className="mt-30">
        <FormLabel htmlFor="documentNumber">Número de {getDocumentTypeName()}</FormLabel>
        <Input
          id="documentNumber"
          name="documentNumber"
          value={patient?.document_number}
          placeholder="Número de run o pasaporte"
          fullWidth
          disabled={true}
          className="mt-10"
        />
      </fieldset>

      <fieldset className="mt-30">
        <FormLabel htmlFor="phone">Teléfono</FormLabel>
        <Input
          id="phone"
          name="phone"
          value={patient?.phone}
          placeholder="Teléfono"
          fullWidth
          disabled={true}
          className="mt-10"
        />
      </fieldset>

      {patient === null && <FormFieldLoading overlay />}
    </div>
  )
}

export { ContactPatientForm }